/** Em dash — placeholder shown when a cell/field has no value. */
export const EM_DASH = '\u2014'

export const USER_UPDATE_SUCCESSFULLY = 'User updated successfully.'

export const USER_UPDATE_FAILED = 'Error updating user.'

export const USER_ROLE_FIELD_TOOLTIP = `Access Roles grant access to Morpheus and other parts of the system.
 Only Roles associated to the RESI line of business may be edited here. USE WITH CARE!`

export const USER_PARTY_ROLE_FIELD_TOOLTIP = `Party Roles do not grant access, but instead designate the type of
user as they are related to the system and the business.`

export const TRACKED_ADDRESS_FIELDS = [
  'municipality', // Irvine
  'country_primary_subdivision', // CA
  'postal_code', // 92627
]

export const ID_VERIFICATION_MODAL_HEADER = 'Reset ID Verification'
export const ID_VERIFICATION_MODAL_CONTENT =
  'You are about to reset an ID flagged as fraud. Are you sure?'

export const MORPHEUS_LOGS_DRAWER_COPY_TITLE =
  'Data successfully copied to clipboard'

// Schedule (events/venues)
export const DEBOUNCE_WAIT = 500
export const FORM_UPDATE_WARNING =
  'To finalize your updates, you must click the Save button above.'
export const FORM_RESET = 'Form has been reset'
export const POST_BULK_UPDATE_DELAY = 3000
export const VENUE_COUNT_FOR_EMPTY_SCHEDULES = 1
export const MAX_EVENT_VENUE_ALLOWED = 675
export const EVENT_VENUE_TEMPLATE_ADDED = 'Venue Template Added'
export const EVENT_VENUE_TEMPLATE_REMOVED = 'Venue Template Removed'
export const EVENT_VENUE_TEMPLATE_EXISTS = 'Venue Template already in the List'
export const EVENT_VENUE_TEMPLATE_MAX_REACHED = `You have reached the max limit of ${MAX_EVENT_VENUE_ALLOWED} Venue Templates`
export const EVENT_VENUE_MAX_REACHED = `You have reached the max limit of ${MAX_EVENT_VENUE_ALLOWED} Venue`
export const EVENT_FORM_EVENT_TEMPLATE_ADDED = 'Event Template Data Imported'
export const SMALL_BATCH_THRESHOLD_COUNT = 100
export const SMALL_BATCH_OF_VENUES_TIMEOUT = 10000
export const LARGE_BATCH_OF_VENUES_TIMEOUT = 60000
